import { store } from "store/store";

export const getToken = () => {
  return store.getState().auth.authData.access_token;
};
